module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/news_created-38dc5b2c76084fd303885c6f7e0d7b00.png";